import { MediaTransmittersTable } from "@/components/media-transmitters/media-transmitters-table";

export function MediaTransmittersPage() {
	return (
		<div className="flex min-h-0 flex-1 flex-col gap-4 p-4 lg:p-6">
			<MediaTransmittersTable />
		</div>
	);
}
